import { domToReact, Element } from "html-react-parser";
import { Fragment } from "react";

export const Iframe = (domNode: Element): JSX.Element | undefined => {
  if (domNode.attribs && domNode.attribs.src) {
    const domNodeDeepClone = structuredClone(domNode);
    domNodeDeepClone.attribs.class = "mx-auto";

    return <Fragment>{domToReact([domNodeDeepClone])}</Fragment>;
  }

  return <Fragment>{domToReact([domNode])}</Fragment>;
};
